
import {
  defineComponent,
  ref,
  computed,
  PropType,
  watch,
  watchEffect,
} from 'vue';
import { _CreatedApp } from '../composables/useAppInfo';
import type {
  IAppInfoItem,
} from '@/api/manage-app/app-manage/index.d';
import {
  UPDATE_DIMENSION_ENUM,
  UPDATE_DIMENSION_LIST,
  USER_SYSTEM_LIST,
  ADAPTATION_SYSTEM_ENUM,
  ADAPTATION_SYSTEM_LIST,
} from '@/constant';
import { IFileData } from '@/components/uploader/packages/types';
import checkFile from '@/components/uploader/packages/utils/check-file';

export default defineComponent({
  name: 'CreatedApp',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountAppItem: {
      type: Object as PropType<IAppInfoItem>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const appLogoList = ref<Partial<IFileData>[]>([]);

    const formData = ref<Partial<IAppInfoItem>>({
      appName: '', // 应用名称
      appCode: '', // app的编码
      appLogo: '', // app的logo
      updateDimension: '', // 更新维度
      dataChannel: '', // 用户数据来源
      adaptiveSystem: '', // 适配系统
      androidAddress: '', // androidApp的下载地址
      iosAddress: '', // iosApp的下载地址
    });

    const {
      handleSave,
      handleClose,
    } = _CreatedApp(
      formData,
      emit as any,
    );

    const close = () => {
      appLogoList.value = [];
      handleClose();
    };

    watch(() => props.accountAppItem, (val) => {
      if (val.id) {
        formData.value = val;
        appLogoList.value = [{
          url: val.appLogo,
        }];
        formData.value.adaptiveSystem = formData.value.adaptiveSystem!.split(',') as any;
      } else {
        formData.value = Object.assign({}, {
          appName: '', // 应用名称
          appCode: '', // app的编码
          appLogo: '', // app的logo
          updateDimension: '', // 更新维度
          dataChannel: '', // 用户数据来源
          adaptiveSystem: '', // 适配系统
          androidAddress: '', // androidApp的下载地址
          iosAddress: '', // iosApp的下载地址
        });
      }
    });

    const handleChangeDimension = () => {
      formData.value.dataChannel = '';
    };
    const rules = ref(
      {
        appName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
        ],
        appCode: [
          { required: true, message: '请选择应用编码', trigger: 'blur' },
        ],
        appLogo: [
          { required: true, message: '请上传应用logo', trigger: 'change' },
        ],
        updateDimension: [
          { required: true, message: '请选择更新维度', trigger: 'blur' },
        ],
        dataChannel: [
          { required: true, message: '请选择用户体系', trigger: 'change' },
        ],
        adaptiveSystem: [
          { required: true, message: '请选择适配系统', trigger: 'blur' },
        ],
        androidAddress: [
          { required: true, type: 'url', message: '请输入正确的Android下载地址', trigger: 'blur' },
        ],
        iosAddress: [
          { required: true, type: 'url', message: '请输入正确的iosAddress下载地址', trigger: 'blur' },
        ],
      },
    );
    watchEffect(() => {
      rules.value.dataChannel[0].required = formData.value.updateDimension === UPDATE_DIMENSION_ENUM.DEPARTMENT;
      const { adaptiveSystem } = formData.value;
      const androidAddressRequired = adaptiveSystem?.includes(ADAPTATION_SYSTEM_ENUM.android) as boolean;
      const iosAddressRequired = adaptiveSystem?.includes(ADAPTATION_SYSTEM_ENUM.ios) as boolean;
      rules.value.androidAddress[0].required = androidAddressRequired;
      rules.value.iosAddress[0].required = iosAddressRequired;
      androidAddressRequired || (formData.value.androidAddress = '');
      iosAddressRequired || (formData.value.iosAddress = '');
    });

    watch(() => appLogoList.value, (val) => {
      let appLogo = '';
      if (val.length) {
        appLogo = val[0].url as string;
      }
      formData.value.appLogo = appLogo;
    });

    return {
      formData,
      selfVisible,
      rules,
      handleSave,
      close,
      handleChangeDimension,
      UPDATE_DIMENSION_ENUM,
      UPDATE_DIMENSION_LIST,
      USER_SYSTEM_LIST,
      ADAPTATION_SYSTEM_ENUM,
      ADAPTATION_SYSTEM_LIST,
      appLogoList,
      checkFile,
    };
  },
});
